<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/cms/static-pages'">Pages</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add page</span>
      } @else {
        <span class="fs-5 fw-bold mb-0">Edit page</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3">

          <div [class.col-6]="!isCreate()" [class.col]="isCreate()">
            <div class="row">
              <div class="col-md-3">
                <label for="name" class="form-label">Name</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-tag"></i></span>
                  <input id="name" type="text" class="form-control" formControlName="name">
                </div>
              </div>

              <div class="col-md-3">
                <label for="product" class="form-label">Brand</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-box"></i></span>
                  <select id="product" class="form-select" formControlName="productId" (change)="refreshLocales()">
                    <option [ngValue]="null">Select brand</option>
                    @for (product of products; track product.id) {
                      <option [ngValue]="product.id">{{ product }}</option>
                    }
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <label for="language" class="form-label">Language</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-link"></i></span>
                  <select id="language" class="form-select" formControlName="locale" (change)="refreshDomains()">
                    <option [ngValue]="null" disabled>Select language</option>
                    @for (locale of availableLocales; track locale) {
                      <option [ngValue]="locale">{{ locale }}</option>
                    }
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <label for="domain" class="form-label">Domain</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-link"></i></span>
                  <select id="domain" class="form-select" formControlName="domainId">
                    <option [ngValue]="null" disabled>Select domain ({{ availableDomains.length }})</option>
                    @for (availableDomain of availableDomains; track availableDomain.id) {
                      <option [ngValue]="availableDomain.id">{{ availableDomain }}</option>
                    }
                  </select>
                  @if (availableDomainLoading) {
                    <app-element-loader class="loader"></app-element-loader>
                  }
                </div>
              </div>

              @if (isCreate()) {
                <div class="col-auto">
                  <label class="form-label"> </label><br>
                  <button type="submit" class="btn btn-primary fw-bold">Create</button>
                </div>
              } @else {
                <div class="col-md-3">
                  <label for="pageType" class="form-label">Type</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-bookmark"></i></span>
                    <select id="pageType" class="form-select" formControlName="pageTypeId">
                      <option [ngValue]="null">Select type</option>
                      @for (pageType of pageTypes; track pageType.id) {
                        <option [ngValue]="pageType.id">{{ pageType }}</option>
                      }
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="slug" class="form-label">Slug</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-tag"></i></span>
                    <input id="slug" type="text" class="form-control"
                           placeholder="de-DE/lp/a23cveD    qz/ze2d0x    a1az1p4" formControlName="slug">
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="site" class="form-label">Access rights</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-lock"></i></span>
                    <select id="site" class="form-select" formControlName="scope">
                      <option value="public">Public</option>
                      <option value="private">Private</option>
                      <option value="protected">Protected</option>
                    </select>
                  </div>
                </div>

                <div class="col">
                  <label for="status" class="form-label">Status</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-check"></i></span>
                    <select id="status" class="form-select" formControlName="status">
                      <option [ngValue]="StaticPageStatus.ACTIVE">Active</option>
                      <option [ngValue]="StaticPageStatus.DISABLED">Disabled</option>
                      <option [ngValue]="StaticPageStatus.PENDING">Pending</option>
                    </select>
                  </div>
                </div>
              }
            </div>

            @if (!isCreate()) {
              <div class="row mt-3">
                <div class="col">
                  <label for="published-at" class="form-label">Publication date</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-calendar"></i></span>
                    <input id="published-at" type="datetime-local" class="form-control" formControlName="publishedAt">
                  </div>
                </div>

                <div class="col-auto">
                  <label class="form-label"> </label>
                  <div class="input-group">
                    <button type="submit" class="btn btn-primary fw-bold">
                      @if (isCreate()) {
                        Create
                      } @else {
                        Update
                      }
                    </button>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col">
                  <code-editor formControlName="htmlContent" [extensions]="extensions" class="html-editor"/>
                </div>
              </div>
            }
          </div>

          @if (!isCreate()) {
            <div class="col-6">
              <div class="row">
                <div class="col">
                  <ul class="nav nav-tabs mb-3" role="tablist">
                    <span (click)="switchTab('assets')" [class.active]="tab === 'assets'"
                          class="nav-link text-primary fw-bold" role="button">Assets</span>
                    <span (click)="switchTab('widgets')" [class.active]="tab === 'widgets'"
                          class="nav-link text-primary fw-bold" role="button">Widgets</span>
                    <span (click)="switchTab('content-library')" [class.active]="tab === 'content-library'"
                          class="nav-link text-primary fw-bold" role="button">Content library</span>
                    <span (click)="switchTab('preview')" [class.active]="tab === 'preview'"
                          class="nav-link text-primary fw-bold" role="button">Preview</span>
                  </ul>
                </div>
              </div>

              @switch (tab) {
                @case ('assets') {
                  <div class="row">
                    <div class="col">
                      <div
                        class="dropzone mt-4"
                        (click)="fileInput.click()"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        (drop)="onDrop($event)"
                        [class.is-dragover]="isDragOver">
                        <input
                          #fileInput
                          type="file"
                          class="d-none"
                          multiple
                          (change)="onFileSelected($event)"/>

                        @if (isUploading) {
                          <div class="dropzone-content">
                            <div class="fw-bold">Uploading…</div>

                            <div class="progress w-100" style="max-width: 360px;">
                              <div
                                class="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                [style.width.%]="uploadProgress"
                                [attr.aria-valuenow]="uploadProgress"
                                aria-valuemin="0"
                                aria-valuemax="100">
                                {{ uploadProgress }}%
                              </div>
                            </div>

                            <div class="small opacity-75">
                              {{ uploadedCount }}/{{ totalCount }} file(s)
                            </div>
                          </div>
                        }

                        @if (!isUploading) {
                          <div class="dropzone-content">
                            <i class="bi bi-upload"></i>
                            <div class="fw-bold">Drag & Drop</div>
                            <div class="small opacity-75">or click to select</div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  @if (staticPageImages.length) {
                    <div class="row mt-3">
                      <div class="col">
                        <button (click)="autoReplaceAll()" class="btn btn-primary" type="button"
                                title="Automatically replace all filenames with their URLs in the whole page (HTML, CSS & JS).">
                          <i class="bi bi-magic"></i> Replace all
                        </button>
                      </div>
                    </div>
                  }

                  @for (staticPageImage of staticPageImages; track staticPageImage.id) {
                    <div class="row mt-3">
                      <div class="col">
                        <div class="align-content-around d-flex align-items-center">
                          @if (staticPageImage.isCss()) {
                            <i class="bi bi-filetype-css fs-2 me-3 ps-2"></i>
                          } @else if (staticPageImage.isJs()) {
                            <i class="bi bi-filetype-js fs-2 me-3 ps-2"></i>
                          } @else if (staticPageImage.isVideo()) {
                            <i class="bi bi-filetype-mp4 fs-2 me-3 ps-2"></i>
                          } @else {
                            <a [href]="getImageUrl(staticPageImage)" target="_blank">
                              <img [src]="getImageUrl(staticPageImage)" class="img-fluid me-3" width="42"/>
                            </a>
                          }

                          <button (click)="deleteImage(staticPageImage)" class="btn btn-danger me-3"
                                  title="Delete this image" type="button">
                            <i class="bi bi-trash-fill"></i>
                          </button>

                          <copy-to-clipboard [content]="getImageUrl(staticPageImage)" [displayContent]="false"
                                             tooltip="Click to copy link">
                            <button class="btn btn-primary me-3" type="button"><i class="bi bi-copy"></i></button>
                          </copy-to-clipboard>

                          <button (click)="autoReplace(staticPageImage)" class="btn btn-primary me-3"
                                  title="Click to automatically replace the link in the HTML." type="button">
                            <i class="bi bi-magic"></i>
                          </button>

                          <div class="me-3"><b>[
                            <copy-to-clipboard [content]="staticPageImage.document.filename ?? ''"
                                               tooltip="Click to copy filename"></copy-to-clipboard>
                            ]</b></div>

                          <div>
                            <copy-to-clipboard [content]="getImageUrl(staticPageImage)"></copy-to-clipboard>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }
                @case ('widgets') {
                  <div class="row mb-3 g-2">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-search"></i></span>
                        <input class="form-control" placeholder="Search by name..."
                               [ngModel]="widgetName" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="widgetNameChange.next($event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-box"></i></span>
                        <app-dropdown-select [(ngModel)]="widgetProductId" [ngModelOptions]="{standalone: true}"
                                             [multiple]="true" placeholder="Brand"
                                             (ngModelChange)="onWidgetProductChange()">
                          @for (product of products; track product.id) {
                            <app-dropdown-select-option [value]="product.id">
                              {{ product }}
                            </app-dropdown-select-option>
                          }
                        </app-dropdown-select>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-translate"></i></span>
                        <app-dropdown-select [(ngModel)]="widgetLang" [ngModelOptions]="{standalone: true}"
                                             [multiple]="true" placeholder="Language"
                                             (ngModelChange)="onWidgetLangChange()">
                          @for (locale of locales; track locale) {
                            <app-dropdown-select-option [value]="locale">
                              {{ locale }}
                            </app-dropdown-select-option>
                          }
                        </app-dropdown-select>
                      </div>
                    </div>
                  </div>

                  <div class="row g-2" style="max-height: 500px; overflow-y: auto;">
                    @for (widget of widgets; track widget.id) {
                      <div class="col-6">
                        <div class="card h-100 widget-card position-relative">
                          <div class="card-body p-2">
                            <div class="fw-bold text-truncate pe-5">{{ widget.name }}</div>
                            <div class="d-flex gap-1 mt-1">
                              <button class="btn btn-outline-secondary btn-sm" type="button"
                                      (click)="copyWidgetTag(widget)">Copy
                              </button>
                              <button class="btn btn-outline-primary btn-sm" type="button"
                                      (click)="insertWidgetTag(widget)">Insert
                              </button>
                              <button class="btn btn-outline-info btn-sm" type="button"
                                      (click)="viewWidget(widget)">View
                              </button>
                            </div>
                            @if (widget.site && widget.site.product) {
                              <div
                                class="position-absolute top-50 end-0 translate-middle-y me-2 d-flex flex-column align-items-end gap-1">
                                <span class="badge bg-primary">{{ widget.site.product }}</span>
                                <div class="d-flex gap-1">
                                  @for (lang of widget.site.product.languages; track $index) {
                                    <img [ngSrc]="langService.getFlag(lang ?? '')" [alt]="lang" width="18" height="18">
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    } @empty {
                      <div class="col">
                        <p class="text-muted text-center mt-3">No widgets found.</p>
                      </div>
                    }
                  </div>
                }
                @case ('content-library') {
                  <div class="row mb-3 g-2">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-search"></i></span>
                        <input class="form-control" placeholder="Search by name..."
                               [ngModel]="assetName" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="assetNameChange.next($event)"/>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-funnel"></i></span>
                        <app-dropdown-select [(ngModel)]="assetTypeFilter" [ngModelOptions]="{standalone: true}"
                                             [multiple]="true" placeholder="Type"
                                             (ngModelChange)="onAssetTypeChange()">
                          <app-dropdown-select-option value="image">Image</app-dropdown-select-option>
                          <app-dropdown-select-option value="video">Video</app-dropdown-select-option>
                          <app-dropdown-select-option value="html">HTML</app-dropdown-select-option>
                          <app-dropdown-select-option value="css">CSS</app-dropdown-select-option>
                          <app-dropdown-select-option value="js">JS</app-dropdown-select-option>
                        </app-dropdown-select>
                      </div>
                    </div>
                  </div>

                  <div class="row g-2" style="max-height: 500px; overflow-y: auto;">
                    @for (asset of assets; track asset.id) {
                      <div class="col-6">
                        <div class="card h-100 widget-card"
                             [class.border-primary]="selectedAsset?.id === asset.id"
                             (click)="selectAsset(asset)" role="button">
                          <div class="card-body p-2">
                            <div class="d-flex align-items-center gap-2">
                              <span class="badge bg-secondary">{{ asset.type }}</span>
                              <span class="fw-bold text-truncate">{{ asset.name }}</span>
                            </div>

                            @if (selectedAsset?.id === asset.id) {
                              <div class="mt-2 border-top pt-2">
                                @if (asset.type === 'image') {
                                  <div class="row g-1 mb-2">
                                    <div class="col-6">
                                      <label class="form-label small mb-0">Width</label>
                                      <input type="text" class="form-control form-control-sm"
                                             [(ngModel)]="assetImageWidth" [ngModelOptions]="{standalone: true}"
                                             placeholder="100%">
                                    </div>
                                    <div class="col-6">
                                      <label class="form-label small mb-0">Height</label>
                                      <input type="text" class="form-control form-control-sm"
                                             [(ngModel)]="assetImageHeight" [ngModelOptions]="{standalone: true}"
                                             placeholder="auto">
                                    </div>
                                  </div>
                                }

                                @if (asset.type === 'video') {
                                  <div class="row g-1 mb-2">
                                    <div class="col-6">
                                      <label class="form-label small mb-0">Width</label>
                                      <input type="text" class="form-control form-control-sm"
                                             [(ngModel)]="assetVideoWidth" [ngModelOptions]="{standalone: true}"
                                             placeholder="100%">
                                    </div>
                                    <div class="col-6">
                                      <label class="form-label small mb-0">Height</label>
                                      <input type="text" class="form-control form-control-sm"
                                             [(ngModel)]="assetVideoHeight" [ngModelOptions]="{standalone: true}"
                                             placeholder="auto">
                                    </div>
                                  </div>
                                  <div class="d-flex flex-wrap gap-2 mb-2">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="checkbox" id="videoControls-{{ asset.id }}"
                                             [(ngModel)]="assetVideoControls" [ngModelOptions]="{standalone: true}">
                                      <label class="form-check-label small"
                                             for="videoControls-{{ asset.id }}">Controls</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="checkbox" id="videoAutoplay-{{ asset.id }}"
                                             [(ngModel)]="assetVideoAutoplay" [ngModelOptions]="{standalone: true}">
                                      <label class="form-check-label small"
                                             for="videoAutoplay-{{ asset.id }}">Autoplay</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="checkbox" id="videoMuted-{{ asset.id }}"
                                             [(ngModel)]="assetVideoMuted" [ngModelOptions]="{standalone: true}">
                                      <label class="form-check-label small"
                                             for="videoMuted-{{ asset.id }}">Muted</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="checkbox" id="videoLoop-{{ asset.id }}"
                                             [(ngModel)]="assetVideoLoop" [ngModelOptions]="{standalone: true}">
                                      <label class="form-check-label small" for="videoLoop-{{ asset.id }}">Loop</label>
                                    </div>
                                  </div>
                                }

                                @if (asset.type === 'css' || asset.type === 'js') {
                                  <p class="small text-muted mb-2">
                                    @if (asset.type === 'css') {
                                      <i
                                        class="bi bi-info-circle me-1"></i>Will be inserted as &lt;link&gt; in &lt;head&gt;
                                    } @else {
                                      <i
                                        class="bi bi-info-circle me-1"></i>Will be inserted as &lt;script&gt; in &lt;head&gt;
                                    }
                                  </p>
                                }

                                <button class="btn btn-outline-primary btn-sm w-100" type="button"
                                        (click)="insertAsset(asset)">
                                  <i class="bi bi-box-arrow-in-down me-1"></i>Insert
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    } @empty {
                      <div class="col">
                        <p class="text-muted text-center mt-3">No assets found.</p>
                      </div>
                    }
                  </div>
                }
                @case ('preview') {
                  <div class="row mb-3 g-2">
                    <div class="col">
                      <app-static-page-viewer [staticPage]="staticPage"></app-static-page-viewer>
                    </div>
                  </div>
                }
              }

              <div class="row mt-4">
                <div class="col text-end">
                  <button type="submit" class="btn btn-primary fw-bold">Update</button>
                </div>
              </div>
            </div>
          }
        </div>
      </form>
    </div>
  </div>
}
